import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';
import styles from './chart.css';


const DoughnutChart = ({ data, options }) => {
  if (data.datasets.length === 0) return (<div />);

  return (
    <div className={styles.container}>
      <Doughnut
        data={data}
        options={options}
      />
    </div>
  );
};

DoughnutChart.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.array.isRequired,
    datasets: PropTypes.array.isRequired,
  }).isRequired,
  options: PropTypes.object,
};

export default DoughnutChart;
